<template>
  <chart-container
    :titleChart="title"
    @onCSVDownload="downloadCSVGraphs()"
    @zoomEnabled="zoomGraph(true)"
    @zoomDisabled="zoomGraph(false)"
    :downloadId="containerId"
    :specificSiteId="specificSiteId"
    :zoomGraphValue="zoomGraphValue"
    :downloadShow="vis ? (vis.dataSource.data.length && vis.totalConsent ? true : false) : false"
    :isZoomEnabled="vis ? (vis.dataSource.data.length && vis.totalConsent ? true : false) : false"
  >
    <!-- change dynamic class names -->
    <span slot="body">
      <div class=".thread-consent-ct1 recruitment-bar-container" id="doughnut-chart" v-if="vis ? vis.dataSource.data.length && vis.totalConsent : false" :class="{ 'hide-study-roles-titles': specificSiteId.length > 0 }">
        <div v-if="zoomGraphValueChild">
          <doughnut-chart :vis="newVis" :height="height" />
        </div>
        <doughnut-chart v-else :vis="vis" :height="height" />
      </div>
      <div v-else class=".thread-consent-ct1 recruitment-bar-container align-center">
        <div class="card-text-title no-data" v-if="dataLoaded">No Data In</div>
      </div>
    </span>
  </chart-container>
</template>

<script>
import RecruitmentFusionDoughnutChart from "../charts/fusion/doughnut-chart.vue";
import { downloadCSV } from "../../services/visualization/data-management";
import ChartContainer from "./chart-container.vue";
import map from "lodash/map";
export default {
  props: {
    studyId: { type: String, default: "" },
    vis: { type: Object, default: null },
    title: {
      type: String,
      default: "Default Fusion Doughnut Card Title"
    },
    zoomGraphValue: { type: String, default: "" },
    containerId: { type: String },
    specificSiteId: { type: Array, default: () => [] },
    dataLoaded: { type: Boolean, default: false },
    checkedSitesApply: { type: Array, default: () => [] },
    checkedCountriesApply: { type: Array, default: () => [] }
  },
  data() {
    return {
      data: null,
      zoomGraphValueChild: "",
      height: "250",
      newVis: []
    };
  },
  watch: {
    zoomGraphValue: function(newVal) {
      this.zoomGraphValueChild = newVal;
      if (newVal == "") {
        this.height = "250";
      }
    },
    vis() {
      this.newVis = JSON.parse(JSON.stringify(this.vis));
      this.newVis.dataSource.chart.legendPosition = "right";
    }
  },
  components: {
    ChartContainer,
    "doughnut-chart": RecruitmentFusionDoughnutChart
  },
  methods: {
    downloadCSVGraphs() {
      const dataTotal = this.vis.dataSource.data;
      let header = [];
      const newArr = [];
      header = ["Consent Name", "Number of Consents"];
      const orderArr = map(dataTotal, "value");
      const sumTotal = orderArr.reduce((a, b) => a + b);
      orderArr.unshift(`${sumTotal}`);
      const labelArr = map(dataTotal, "label");
      labelArr.unshift("Total");
      orderArr.map((row, i) => {
        newArr.push([labelArr[i], row]);
      });
      downloadCSV(this.title, header, newArr, this.specificSiteId);
    },
    zoomGraph(status) {
      if (status) {
        this.zoomGraphValueChild = true;
        this.height = "400";
        this.$emit("zoomEnabled");
      } else {
        this.zoomGraphValueChild = false;
        this.height = "250";
        this.$emit("zoomDisabled");
      }
    }
  }
};
</script>
